import React from 'react'
import styles from './City.module.scss'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'

export const City = ({ city, action, index, menu }) => {
  return (
    <div
      className={`${styles.reasonsContainer} ${index % 2 === 0 ? styles.colorBg : ''}`}
    >
      <div className={styles.containerInf}>
        <div className={`${styles.infStyl} ${styles.name}`}>{city.name}</div>
        <div className={styles.buttons}>
          <ActionMenu
            menu={menu}
            action={(actionType) => action(actionType, null, city)}
          />
        </div>
      </div>
    </div>
  )
}
